import React from "react"
import axios from 'axios'
import $ from "jquery";
import Chart from 'chart.js';

var snackbar

function insertPrefixZero(num) {
    return num < 10 ? `0${num}` : num
}

class UsersStatsBox extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.loadServices()
        setTimeout(()=>{
            const { error, isLoaded, items } = this.props.state
           
            var ctx = document.getElementById('myChart');
            var myChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels:  items.map(e=>`${insertPrefixZero(e.date)}.${insertPrefixZero(e.month)}.${insertPrefixZero(e.year)}`).reverse(),
                    datasets: [{
                        label: '',
                        data:  items.map(e=>e.newUsers).reverse(),
                        fill: false,
                        borderColor: "#6200ee",
                        borderWidth: 3,
                        yAxisID: "y1"
                    }
                    ]
                },
                options: {
                    legend: {
                        display: false,
                        labels: {
                            // This more specific font property overrides the global property
                            fontColor: 'white'
                        }
                    },
                    scales: {
                        yAxes: [{
							type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
							display: true,
							position: 'left',
							id: 'y1',
						}],
                    }
                }
            });
        }, 1500)
    }

    render(props) {

        const { error, isLoaded, items } = this.props.state;
        if (error) {
            return <div>Ошибка: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Загрузка...</div>;
        } else {
            return (
                <div className="ibox" style={{ flex: "0 0 1000px", minWidth: "100%", margin: "24px 24px 24px 0", overflowX: "auto" }}>
                    <h3 className="ibox_title" style={{ paddingRight: "10px" }}>Новые пользователи</h3>
                    <div className="ibox_content" style={{ padding: "16px" }}>
                        <canvas id="myChart" style={{ width: "100%", height: "300px" }}></canvas>
                    </div>
                </div>
            );
        }


    }
}


class OrdersStatsBox extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.loadServices()
        setTimeout(()=>{
            const { error, isLoaded, items } = this.props.state
           
            var ctx = document.getElementById('myChart2');
            var myChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels:  items.map(e=>`${insertPrefixZero(e.date)}.${insertPrefixZero(e.month)}.${insertPrefixZero(e.year)}`).reverse(),
                    datasets: [{
                        label: '',
                        data:  items.map(e=>e.boostProfit).reverse(),
                        fill: false,
                        borderColor: "#6200ee",
                        borderWidth: 3,
                        yAxisID: "y1"
                    }
                    ]
                },
                options: {
                    legend: {
                        display: false,
                        labels: {
                            // This more specific font property overrides the global property
                            fontColor: 'white'
                        }
                    },
                    scales: {
                        yAxes: [{
							type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
							display: true,
							position: 'left',
							id: 'y1',
						}],
                    }
                }
            });
        }, 1500)
    }

    render(props) {

        const { error, isLoaded, items } = this.props.state;
        if (error) {
            return <div>Ошибка: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Загрузка...</div>;
        } else {
            return (
                <div className="ibox" style={{ flex: "0 0 1000px", minWidth: "100%", margin: "24px 24px 24px 0", overflowX: "auto" }}>
                    <h3 className="ibox_title" style={{ paddingRight: "10px" }}>Прибыль NakrutkaTOP</h3>
                    <div className="ibox_content" style={{ padding: "16px" }}>
                        <canvas id="myChart2" style={{ width: "100%", height: "300px" }}></canvas>
                    </div>
                </div>
            );
        }


    }
}


class NTGStatsBox extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.loadServices()
        setTimeout(()=>{
            const { error, isLoaded, ntg } = this.props.state
           
            var ctx = document.getElementById('myChart3');
            var myChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels:  ntg.map(e=>e.date).reverse(),
                    datasets: [{
                        label: '',
                        data:  ntg.map(e=>e.profit).reverse(),
                        fill: false,
                        borderColor: "#6200ee",
                        borderWidth: 3,
                        yAxisID: "y1"
                    }
                    ]
                },
                options: {
                    legend: {
                        display: false,
                        labels: {
                            // This more specific font property overrides the global property
                            fontColor: 'white'
                        }
                    },
                    scales: {
                        yAxes: [{
							type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
							display: true,
							position: 'left',
							id: 'y1',
						}],
                    }
                }
            });
        }, 1500)
    }

    render(props) {

        const { error, isLoaded, ntg } = this.props.state;
        if (error) {
            return <div>Ошибка: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Загрузка...</div>;
        } else {
            return (
                <div className="ibox" style={{ flex: "0 0 1000px", minWidth: "100%", margin: "24px 24px 24px 0", overflowX: "auto" }}>
                    <h3 className="ibox_title" style={{ paddingRight: "10px" }}>Прибыль NiceTG</h3>
                    <div className="ibox_content" style={{ padding: "16px" }}>
                        <canvas id="myChart3" style={{ width: "100%", height: "300px" }}></canvas>
                    </div>
                </div>
            );
        }


    }
}

class StatsTab extends React.Component {
    constructor(props) {
        super(props);
        this.loadServices = this.loadServices.bind(this)

        this.state = {
            error: null,
            isLoaded: false,
            items: [],
            ntg: []
        }

    }

    componentDidMount() {

    }

    loadServices() {
        axios.get("https://nakrutkatop.com:443/api/admin/stats", { withCredentials: true })
            .then(res => {
                document.getElementById("mainContent").style.opacity = 1
                this.setState({
                    isLoaded: true,
                    items: res.data.stats,
                    ntg: res.data.ntg
                }, () => {

                })
            })
    }

    render(props) {
        return <div id="mainContent" style={{ opacity: "0", transition: "1.5s opacity" }}>
            <div className="irow" style={{ display: "flex", flexWrap: "wrap" }}>
                <UsersStatsBox loadServices={this.loadServices} state={this.state} />
                <OrdersStatsBox loadServices={this.loadServices} state={this.state} />
                <NTGStatsBox loadServices={this.loadServices} state={this.state} />
            </div>
        </div>
    }
}

export default StatsTab